/* eslint-disable react/sort-comp */
import React from 'react';
import _ from 'underscore';
import { IMultiLineEllipsisTextProps, IMultiLineEllipsisTextState } from './types';

export class MultiLineEllipsisText extends React.PureComponent<IMultiLineEllipsisTextProps, IMultiLineEllipsisTextState> {
  static defaultProps: Partial<IMultiLineEllipsisTextProps> = {
    className: undefined,
    style: undefined,
    text: '',
  };

  private hiddenTextRef: React.RefObject<HTMLDivElement>;

  private containerRef: React.RefObject<HTMLDivElement>;

  processText = _.debounce(() => {
    if (!this.hiddenTextRef || !this.hiddenTextRef.current) {
      return;
    }

    if (this.containerRef.current) {
      this.hiddenTextRef.current.style.maxWidth = `${this.containerRef.current.clientWidth}px`;
    }
    this.hiddenTextRef.current.style.position = 'absolute';

    const wordArray = this.props.text?.split(' ') || [];
    let newText = wordArray.join(' ');
    this.hiddenTextRef.current.innerText = newText;

    while (this.hiddenTextRef.current.scrollHeight > this.containerRef.current!.offsetHeight) {
      wordArray.pop();
      newText = `${wordArray.join(' ')}...`;

      if (this.hiddenTextRef.current.innerText === newText) {
        break;
      }

      this.hiddenTextRef.current.innerText = newText;
    }

    this.setState({
      processedText: newText,
    });
  }, 100);

  constructor(props: IMultiLineEllipsisTextProps, context: unknown) {
    super(props, context);

    this.state = {
      processedText: '',
    };

    this.hiddenTextRef = React.createRef<HTMLDivElement>();
    this.containerRef = React.createRef<HTMLDivElement>();
  }

  componentDidMount() {
    this.processText();
  }

  componentDidUpdate() {
    this.processText();
  }

  render() {
    return (
      <div className={`multi-line-ellipsis-text-component ${this.props.className}`} style={this.props.style as React.CSSProperties | undefined} ref={this.containerRef}>
        <div className="multi-line-hidden-text" style={{ opacity: 0, zIndex: -2 }} ref={this.hiddenTextRef} />
        <div className="multi-line-processed-text">
          {this.state.processedText}
        </div>
      </div>
    );
  }
}
